import React from 'react';
import { FadeInUp } from './FadeInUp';
export function Trust() {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="trust-section" className="bg-white py-24 lg:py-32" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-150">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-151">
          <FadeInUp className="order-2 lg:order-1" data-id="element-152">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] border border-gray-100" data-id="element-153">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800" alt="Asesoría financiera profesional" className="absolute inset-0 w-full h-full object-cover" data-id="element-154" />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-blue/40 to-transparent" data-id="element-155"></div>
            </div>
          </FadeInUp>

          <div className="order-1 lg:order-2" data-id="element-156">
            <FadeInUp data-id="element-157">
              <div className="grid grid-cols-2 gap-6 mb-12" data-id="element-158">
                <div className="border-l-4 border-vitality-green pl-4" data-id="element-159">
                  <p className="text-3xl font-black text-deep-blue" data-id="element-160">+5,000</p>
                  <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-161">
                    Familias asesoradas
                  </p>
                </div>
                <div className="border-l-4 border-vitality-green pl-4" data-id="element-162">
                  <p className="text-3xl font-black text-deep-blue" data-id="element-163">98%</p>
                  <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-164">
                    De satisfacción
                  </p>
                </div>
              </div>
            </FadeInUp>

            <FadeInUp delay={0.1} data-id="element-165">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deep-blue mb-6 leading-tight tracking-tight" data-id="element-166">
                Miles de familias ya están creciendo sus ahorros y protegiendo
                su futuro con un IUL.
              </h2>
            </FadeInUp>

            <FadeInUp delay={0.2} data-id="element-167">
              <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed font-light" data-id="element-168">
                No dejes el futuro de los tuyos al azar. Agenda tu asesoría y da
                el primer paso hoy hacia una tranquilidad financiera real y
                duradera.
              </p>
            </FadeInUp>

            <FadeInUp delay={0.3} data-id="element-169">
              <a href="#lead-form" onClick={scrollToForm} className="inline-flex items-center justify-center bg-deep-blue hover:bg-blue-900 text-white font-semibold text-lg px-8 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-170">
                Agendar mi asesoría ahora
              </a>
            </FadeInUp>
          </div>
        </div>
      </div>
    </section>;
}